
import { isIOS } from "@/services/deviceDetection"
import { StringToSeconds } from "@/services/DurationFormatter"
import { GlobalDataKey } from "@/symbols"
import injectStrict from "@/utils/injectStrict"
import { computed, defineComponent, PropType, ref, Ref } from "vue"

export default defineComponent({
  props: {
    continuefromTime: { type: Number, required: true },
    hasEnded: { type: Object as PropType<Ref<Boolean>>, required: true },
    dur: { type: Object as PropType<Ref<Number>>, required: true },
    duration: { type: String, required: true },
    updateWithFullVideo: { type: Function, required: true }
  },
  setup(props) {
    const globalData = injectStrict(GlobalDataKey)
    const pressed_close = ref(false)
    let showEndedPage = computed(() => {
      pressed_close.value = false
      return (
        props.continuefromTime > 0 &&
        props.hasEnded.value &&
        globalData.value.fullVideoInfo.isReady &&
        props.dur.value == StringToSeconds(props.duration)
      )
    })
    let cont_play_btn_txt = computed(() =>
      isIOS(navigator.platform, navigator.maxTouchPoints)
        ? `Watch full video`
        : `Continue watching`
    )
    return { showEndedPage, cont_play_btn_txt, pressed_close }
  },
  methods: {
    clickClose() {
      this.pressed_close = true
    }
  }
})
